import React, { useState } from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Box,
  Button,
  Stack,
} from "@mui/material";
import { CustomTitle } from "../../HelperFunctions/HelperFunctions";
import PeriodicReportsScheduler from "./PeriodicReportsScheduler";
import CustomReportsScheduler from "./CustomReportsScheduler";
import SchedulerDialog from "../../Components/SchedulerDialog";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import { useLoaderData } from "react-router-dom";

const Scheduler = () => {
  const { privileges = {}, clientID, clientName } = useLoaderData();
  const { Create = false, Update = false, Delete = false } = privileges;

  const [selectedTab, setSelectedTab] = useState("custom_reports");
  const [open, setOpen] = useState(false);
  const [refreshCustomReports, setRefreshCustomReports] = useState(false);
  const [userName, setUserName] = useState(null);

  const handleScheduleSubmit = () => {
    if (selectedTab === "custom_reports") {
      setRefreshCustomReports(true);
    }
  };

  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={2000}
    >
      {/* <Box padding={1}> */}
      <Box padding={0.5} height="100vh" display="flex" flexDirection="column">
        <Stack direction={"row"}
          // justifyContent={"space-between"}
          justifyContent={"flex-end"}
          gap={2}
        >
          {/* <ToggleButtonGroup
            value={selectedTab}
            exclusive
            // onChange={(e, newTab) => newTab && setSelectedTab(newTab)}
            sx={{ borderRadius: "2px" }}
          >
            {["periodic_reports", "custom_reports"].map((key) => (
              <ToggleButton
                key={key}
                value={key}
                sx={{
                  minWidth: "130px",
                  border: "1px solid #009688",
                  height: "30px",
                  fontWeight: 500,
                  fontSize: "13px",
                  color: "#009688",
                  textTransform: "none",

                  "&.Mui-selected": { backgroundColor: "#C1F7E0" },
                }}
              >
                {CustomTitle(key)}
              </ToggleButton>
            ))}
          </ToggleButtonGroup> */}

          <Button
            variant="contained"
            // size='small'
            disableElevation
            disableRipple
            sx={{
              px: 2,
              textTransform: "none",
              backgroundColor: "#b5dcf2",
              color: "#000",
              fontWeight: 500,
              fontSize:13
              // minWidth: "250px",
            }}
            onClick={() =>
              Create
                ? setOpen(true)
                : enqueueSnackbar("You don't have create privileges", {
                  variant: "warning",
                })
            }
          >
            Create New Schedule
          </Button>

          {open && (
            <SchedulerDialog
              open={open}
              onClose={() => setOpen(false)}
              onSubmitSuccess={handleScheduleSubmit}
              userName={userName}

            />
          )}
        </Stack>

        <Box sx={{ fontSize: "14px", color: "#555", flex: 1, overflow: "auto" }} >
          {/* <Box sx={{ mt: 2, fontSize: "14px", color: "#555" }}> */}
          {selectedTab === "periodic_reports" ? (
            <PeriodicReportsScheduler />
          ) : (
            <CustomReportsScheduler
              refresh={refreshCustomReports}
              setRefresh={setRefreshCustomReports}
              onSubmitSuccess={handleScheduleSubmit}
              name={setUserName}
            />
          )}
        </Box>
      </Box>
    </SnackbarProvider>
  );
};

export default Scheduler;
